<!-- ikona w toolbarze -->
<div class="linkBlock" [attr.data-theme]="'dark'">
    <form class="ite-popup"
          [formGroup]="form"
          (click)="$event.stopPropagation()"
          (mousedown)="$event.stopPropagation()"
          >
      <as-input
        formControlName="value"
        label="URL"
        size="medium"
        type="text">
      </as-input>

      <!-- komunikaty błędów -->
      <small class="err" *ngIf="form.controls.value.errors?.required">
        {{'creator.requiredText' | translate}}
      </small>
      <small class="err" *ngIf="form.controls.value.errors?.email">
        {{'creator.requiredEmail' | translate}}
      </small>

     <div align="end" class="actions">
        <as-button
          [useSubmitBehavior]="true"
          [size]="btnSize.Large"
          [variant]="btnVariant.DarkStyle"
          (click)="cancel()"
          [label]="'creator.cancelButton' | translate"
          [customClass]="'w-100'"
        ></as-button>
        <as-button
          [disabled]="form.invalid"
          [useSubmitBehavior]="true"
          [size]="btnSize.Special"
          (click)="confirm()"
          [variant]="btnVariant.Secondary"
          [label]="'creator.saveButton' | translate"
          [customClass]="'w-100'"
        ></as-button>
      </div>
    </form>
  </div>

